// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3CTAV","productName":"Table_productName__1vRXq"};